/* eslint-disable no-param-reassign */

import {
  IPlatformLogStatusDTO,
  IPlatformLogStatusSelectDTO,
  IPlatformLogSWarningSentSelectDTO,
  IPlatformLogTypeSelectDTO,
  PlatformLogStatusEnum,
  PlatformLogStatusTypes,
} from "@hooks/dtos/IPlatformLogDTO";

export const platformLogWarningSentSelect: IPlatformLogSWarningSentSelectDTO[] =
  [
    {
      type: "t",
      text: "Notificado",
    },
    {
      type: "f",
      text: "Não Notificado",
    },
  ];

export const platformLogStatusSelect: IPlatformLogStatusSelectDTO[] = [
  {
    status: "o",
    text: "Online",
  },
  {
    status: "d",
    text: "Lentidão",
  },
  {
    status: "f",
    text: "Offline",
  },
];

export const platformLogTypeSelect: IPlatformLogTypeSelectDTO[] = [
  {
    type: "a",
    text: "Automático",
  },
  {
    type: "m",
    text: "Manual",
  },
];

export const platformLogStatusTypes: IPlatformLogStatusDTO[] = [
  {
    status: PlatformLogStatusEnum.ONLINE,
    text: "Online",
    title: "Plataforma Online.",
    color: "success",
  },
  {
    status: PlatformLogStatusEnum.DEGRADED,
    text: "Lentidão",
    title: "Plataforma está muito lenta.",
    color: "warning",
  },
  {
    status: PlatformLogStatusEnum.OFFLINE,
    text: "Offline",
    title: "Plataforma Offline.",
    color: "danger",
  },
];

export const getPlatformLogStatus = (
  status: PlatformLogStatusTypes
): IPlatformLogStatusDTO => {
  let ret = platformLogStatusTypes.find((x) => x.status === status);
  if (!ret)
    ret = { status: "o", text: "Error", title: "Error", color: "danger" };
  return ret;
};
